import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { bindActionCreators } from 'redux';
import {
  toggleSummary,
  toggleMobileRouteToDashboard
} from '@carvana/purchase-store';
import Landing from './landing';

const mapStateToProps = state => ({
  name: state?.core?.name
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ toggleSummary, toggleMobileRouteToDashboard }, dispatch);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Landing);
